// extracted by mini-css-extract-plugin
export default {"eclipseCtaTooltip":"ybS2ca","eclipseCta":"_aUvKF","primary":"esKfdg","secondary":"OWqe9n","dark":"ur1bQo","disabled":"SVnWUi"};